import {atom} from "recoil";
import {persistentAtom} from "./persisentAtom";


export const categoriesState = atom<any[]>({
  key: 'categoriesState',
  default: [],
})
export const categoryTypesState = atom<any[]>({
  key: 'categoryTypesState',
  default: [],
})

export const interestsState = atom<any[]>({
  key: 'interestsState',
  default: [],
})

export const viewsState = atom<any[]>({
  key: 'viewsState',
  default: [],
})

export const reviewsState = atom<any[]>({
  key: 'reviewsState',
  default: [],
})

export const subscriptionState = atom<any[]>({
  key: 'subscriptionState',
  default: [],
})

export const paymentsState = atom<any[]>({
  key: 'paymentsState',
  default: [],
})

export const userPaymentsState = atom<any[]>({
  key: 'userPaymentsState',
  default: [],
})

export const bookmarksState = atom<any[]>({
  key: 'bookmarksState',
  default: [],
})

export const carouselState= atom<any[]>({
  key: 'carouselState',
  default: [],
})

export const usersState = atom<any[]>({
  key: 'usersState',
  default: [],
})
export const contentState = atom<any[]>({
  key: 'contentState',
  default: [],
})

export const freeContentState = atom<any[]>({
  key: 'freeContentState',
  default: [],
})

export const logState = atom<any[]>({
  key: 'logState',
  default: [],
})

export const oneUserState = atom<any>({
  key: 'oneUserState',
  default: {},
})

export const organisationState = atom<any[]>({
  key: 'organisationState',
  default: [],
})

export const authState = persistentAtom({
  key: 'authState', // unique ID (with respect to other atom<any[]>s/selectors)
  default: {
    isAuthenticated: false,
    token: null,
    user: null,
    isAdmin: false,
    isOrg: false,
  },
});
